export function addGroupFormValidation(value){

    let errors = {};
    if(!value.name){
        errors.name = 'Group name is required';
    }
    
    return errors;


}